import angular from 'angular';
import { DeleteTimeEntryModalComponent } from './delete-time-entry-modal.component';
import { EditTimeEntryModalComponent } from './edit-time-entry-modal.component';

/**
 * A module that provides components used to update time entries.
 */
export const TimeEntryEditModule = angular
    .module("apex.mainApp.timeEntry.edit", [])
    .component("apexDeleteTimeEntryModal", DeleteTimeEntryModalComponent)
    .component("apexEditTimeEntryModal", EditTimeEntryModalComponent)
    .name;
